import * as React from 'react';
import { motion } from 'framer-motion';

const ListItemWrapper = ({ children  })=>/*#__PURE__*/ React.createElement(motion.li, {
        variants: {
            start: {
                opacity: 0
            },
            end: {
                opacity: 1
            }
        },
        className: "recommendation-list__list-item"
    }, children)
;

export { ListItemWrapper };
//# sourceMappingURL=ListItemWrapper.js.map
